export default __webpack_public_path__ + "static/media/i212sk.ad292f3a.webp";